
    import { DotLottie } from "https://esm.sh/@lottiefiles/dotlottie-web";
    window.DotLottie = DotLottie
  